<template>
  <div>
    <div class="tabs is-separatedUnderlined is-fullwidth is-marginless" v-if="!fromQuickview">
      <ul class="has-text-weight-medium">
        <li :class="{'is-active': panel === 'INFOS'}"><a @click="panel = 'INFOS'">Fiche {{fromLead ? 'lead' :
          'contact'}}</a></li>
        <li :class="{'is-active': panel === 'COMMENT'}"><a @click="panel = 'COMMENT'">Commentaire sur le {{fromLead ?
          'lead' : 'contact'}}</a></li>
      </ul>
    </div>
    <div class="has-bg-brand is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall"
         v-if="panel === 'INFOS'">
      <div class="has-text-white is-size-6">
        <span class="icon is-small is-margin-right-xsmall"><i class="fas fa-check-circle"></i></span>
        <i v-if="fromLead">Information obligatoire pour la conversion en contact</i>
        <i v-else>Information obligatoire pour la validation du formulaire</i>
      </div>
    </div>
    <form @submit.prevent.stop="">
      <div v-show="panel === 'INFOS'">
        <div class="columns is-multiline has-bg-grey2 is-border-bottom" v-if="!fromQuickview">
          <div class="column is-gapless is-paddingless is-12 columns is-multiline">
            <div class="column is-padding-left is-padding-right is-padding-top is-padding-bottom"
                 v-if="isAdmin || isManager || isOperator || isSectorManager">
              <div class="field columns is-column is-space-between is-height-full">
                <label class="label" for="referent-user">
                  {{fromLead ? 'Assigner à' : 'Utilisateur Référent'}}
                </label>
                <div v-if="sellers">
                  <multiselect id="referent-user" name="referent-user" v-model="seller" :options="sellers"
                               :multiple="false" :searchable="true"
                               :close-on-select="true" :show-labels="false" :placeholder="''"
                               class="multiselect--option-ico"
                               :custom-label="sellerName" track-by="pk" @search-change="getSellers">
                    <span slot="placeholder" class="multiselect__placeholder">Sélectionnez un utilisateur</span>
                    <span slot="noOptions">La liste est vide</span>
                  </multiselect>
                </div>
              </div>
            </div>

            <div v-if="!isExternal"
                 class="column is-6 is-padding-left is-padding-right is-padding-top is-padding-bottom">
              <div class="field columns is-column is-space-between is-height-full">
                <label class="label" for="origin-contact">Origine <span v-if="!fromLead">du contact</span></label>
                <div v-if="origins">
                  <multiselect id="origin-contact" name="origin-contact" v-model="origin" track-by="pk"
                               :custom-label="originName"
                               group-values="children" group-label="name" :group-select="false"
                               class="multiselect--option-ico"
                               :options="originGroups" :searchable="true" :close-on-select="true" :show-labels="false"
                               @search-change="getOrigins" :placeholder="''">
                    <template slot="clear" slot-scope="props">
                      <div class="multiselect__clear" v-if="origins.length"
                           @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">Oups! Aucune origine trouvée.</span>
                    <span slot="placeholder" class="multiselect__placeholder">Sélectionnez une origine</span>
                    <span slot="noOptions">La liste est vide</span>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline has-bg-light" v-if="!fromQuickview">
          <div class="column is-12 is-padding-left is-padding-right is-padding-top is-padding-bottom">
            <r-label :label="'Nature du contact'" :value="c.nature" :redCheck="true"></r-label>

            <div class="column is-gapless is-paddingless is-12 columns is-multiline">
              <div class="column is-12 is-padding-right-small columns is-variable is-2 is-multiline">
                <div class="column is-4 is-paddingless-bottom is-paddingless-top is-paddingless-left">
                  <input class="checkradiocase is-primary is-fullwidth" id="nature_human" type="radio" name="nature"
                         value="human"
                         v-model="c.nature" :class="{'is-active' : c.nature === 'human'}">
                  <label for="nature_human">Personne physique</label>
                </div>
                <div class="column is-4 is-paddingless-bottom is-paddingless-top is-paddingless-left">
                  <input class="checkradiocase is-primary is-fullwidth" id="nature_corporation" type="radio"
                         name="nature"
                         value="corporation" v-model="c.nature" :class="{'is-active' : c.nature === 'corporation'}">
                  <label for="nature_corporation">Personne morale</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns is-multiline has-bg-light is-border-top" v-if="!isHuman && isCorporation && !fromLead">
          <div class="column is-6 is-padding-bottom is-border-bottom">
            <r-label :label="'Nom société'" :redCheck="true" :value="c.corporation_name"></r-label>
            <v-input id="corporation_name" name="corporation_name" @input="val => c.corporation_name = val"
                     :model="c.corporation_name"
                     v-validate="'required|min:2'"
                     :errors-bag="errors" data-vv-value-path="val" data-vv-as="Nom société">
            </v-input>
          </div>
          <div class="column is-6 is-padding-bottom is-border-bottom">
            <r-label :label="'Siret Société'" :redCheck="true" :value="c.corporation_siret"></r-label>
            <v-input id="corporation_siret" name="corporation_siret" @input="val => c.corporation_siret = val"
                     :model="c.corporation_siret"
                     v-validate="'required|min:2'"
                     :errors-bag="errors" data-vv-value-path="val"
                     data-vv-as="SIRET Société">
            </v-input>
          </div>
        </div>

        <div class="columns is-multiline is-border-top" :class="{'has-bg-light':!fromQuickview}">
          <div class="column is-12 is-paddingless-bottom"
               v-if="!fromQuickview && !isHuman && isCorporation && !fromLead">
            <div class="title is-5">
              <b class="is-uppercase">Informations représentant société</b>
            </div>
          </div>

          <div v-if="!isExternal && fromQuickview && origins"
               class="column is-12 is-padding-left is-padding-right is-padding-top is-paddingless-bottom">
            <div class="field columns is-column is-space-between is-height-full">
              <label class="label" for="origin-contact">Origine <span v-if="!fromLead">du contact</span></label>
              <div v-if="origins">
                <multiselect id="origin-contact" name="origin-contact" v-model="origin" track-by="pk"
                             :custom-label="originName"
                             group-values="children" group-label="name" :group-select="false"
                             class="multiselect--option-ico"
                             :options="originGroups" :searchable="true" :close-on-select="true" :show-labels="false"
                             @search-change="getOrigins" :placeholder="''">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="origins.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucune origine trouvée.</span>
                  <span slot="placeholder" class="multiselect__placeholder">Sélectionnez une origine</span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
          </div>

          <div class="column is-12 is-paddingless-bottom">
            <r-label :label="'Civilité'" :value="c.title" :is-required="true" :redCheck="true"></r-label>
            <div class="column is-gapless is-paddingless is-12 columns is-multiline">
              <div class="column is-12 is-padding-right-small columns is-multiline is-variable is-2">
                <div class="column is-4 is-paddingless-bottom is-paddingless-top is-paddingless-left">
                  <input class="checkradiocase is-primary is-fullwidth" v-validate="'required'" :id="'M'+Date.now()"
                         type="radio" name="title" value="mr" v-model="c.title">
                  <label :for="'M'+Date.now()"><span class="icon is-size-4 is-padding-right"><i class="fas fa-male"></i></span>M.
                  </label>
                </div>
                <div class="column is-4 is-paddingless-bottom is-paddingless-top is-paddingless-left">
                  <input class="checkradiocase is-primary is-fullwidth" :id="'Mme'+Date.now()" type="radio" name="title"
                         value="mrs" v-model="c.title">
                  <label :for="'Mme'+Date.now()"><span class="icon is-size-4 is-padding-right"><i
                    class="fas fa-female"></i></span>Mme. </label>
                </div>
                <p v-if="errors.has('title')" class="help is-danger column is-3 is-paddingless">La civilité est
                  obligatoire.</p>
              </div>
            </div>
          </div>

          <div class="column is-6 is-paddingless-bottom" :class="{'is-12':fromQuickview}">
            <r-label :label="'Nom'" :value="c.last_name" :redCheck="true"></r-label>
            <v-input id="last_name" name="last_name" @input="val => c.last_name = val" :model="c.last_name"
                     v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                     data-vv-as="Nom">
            </v-input>
          </div>

          <div class="column is-6 is-paddingless-bottom" :class="{'is-12':fromQuickview}">
            <r-label :label="'Prénom'" :value="c.first_name" :redCheck="true"></r-label>
            <v-input id="first_name" name="first_name" @input="val => c.first_name = val" :model="c.first_name"
                     v-validate="'required|min:2'" :errors-bag="errors" data-vv-value-path="val"
                     data-vv-as="Prénom">
            </v-input>
          </div>

          <div v-if="!fromQuickview" class="column is-6 is-paddingless-bottom" :class="{'is-12':fromQuickview}">
            <r-label :label="'Nom de naissance'" :value="c.birth_name" :is-required="hasCheck" :redCheck="hasCheck"></r-label>
            <v-input id="birth_name" name="birth_name" @input="val => c.birth_name = val" :model="c.birth_name"
                     v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val"
                     data-vv-as="Nom de naissance">
            </v-input>
          </div>


          <div class="column is-half is-paddingless-bottom" :class="{'is-12':fromQuickview}">
            <r-label :label="'Adresse mail'" :value="c.email" :redCheck="true"></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-min-width-0 is-square">
                  <span class="icon"><i class="fas fa-envelope"></i></span>
                </a>
              </div>
              <div class="control is-expanded">
                <v-input id="email" name="email" @input="val => c.email = val" :model="c.email"
                         v-validate="'required|email'" :errors-bag="errors" data-vv-value-path="val"
                         data-vv-as="Email">
                </v-input>
              </div>
            </div>
          </div>

          <div class="column is-half is-paddingless-bottom" :class="{'is-12':fromQuickview}">
            <r-label :label="'Téléphone (fixe ou mobile)'" :value="c.phone" :redCheck="true"></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-min-width-0 is-square">
                  <span class="icon"><i class="fas fa-mobile-alt"></i></span>
                </a>
              </div>
              <div class="control is-expanded">
                <v-input id="phone" name="phone" @input="val => c.phone = val" :model="c.phone"
                         v-validate="'required'" :errors-bag="errors" data-vv-value-path="val"
                         data-vv-as="Téléphone"
                         v-mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'">
                </v-input>
              </div>
            </div>
          </div>

          <div class="column is-12"
               :class="isCorporation ? 'is-paddingless-top is-paddingless-left is-paddingless-right' : 'is-paddingless'">
            <gmap-input @submit="updateAddress" :redCheck="true" @errorMess='val => errorMess = val '
                        :source="c.address" :from-quickview="fromQuickview" label="Adresse" :fromContact="true"
                        :isRequired="true" name="adresse" :errors-bag="errors"></gmap-input>
          </div>
        </div>

        <!-- Visible only in Spouse mode // toggle more inputs -->
        <div class="columns is-multiline is-margin-top is-12 column is-paddingless"
             v-if="isSpouse" id="complementary"
             :class="" :style="styleBtnToggleMoreInput"
        >
          <a class="column is-12 has-bg-primary is-padding-bottom-small is-padding-top-small"
             @click="moreInputs()"
          >
            <div class="title is-5">
              <b class="is-uppercase has-text-white">
                Informations complémentaires
                <span class="icon"><i class="fas" :class="displayMoreInputs ? 'fa-chevron-up' : 'fa-chevron-down'"></i></span>
              </b>
            </div>
          </a>
        </div>

        <div v-if="!isCorporation && !fromLead"
             class="columns is-multiline"
             :class="{'has-bg-light':!fromQuickview}"
             v-show="displayMoreInputs"
        >
          <div class="column is-12 is-paddingless columns is-multiline">
            <div class="column is-4 is-paddingless-bottom" :class="{'is-12':fromQuickview}">
              <r-label :label="'Date de naissance'" :value="c.birthday" :redCheck="hasCheck"
                       :is-required="hasCheck && isHuman && !isCorporation"></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded has-icons-right">
                  <flat-pickr :config="configDate" type="date" class="input" v-model="c.birthday"></flat-pickr>
                </div>
                <div class="control">
                  <a class="button is-grey is-inverted is-border is-min-width-0 is-square" @click="c.birthday = null">
                    <i class="fas fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-4 is-paddingless-bottom" :class="{'is-12':fromQuickview}">
              <r-label :label="'Lieu de naissance'" :value="c.birthplace" :redCheck="hasCheck"
                       :is-required="hasCheck && isHuman && !isCorporation"></r-label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <input type="text" class="input" v-model="c.birthplace">
                </div>
              </div>
            </div>
            <div class="column is-4 is-paddingless-bottom" :class="{'is-12':fromQuickview}">
              <r-label :label="'Nationalité'" :value="c.nationality" :redCheck="hasCheck"
                       :is-required="hasCheck && isHuman && !isCorporation"></r-label>
              <v-input id="nationality" name="nationality" @input="val => c.nationality = val"
                       :model="c.nationality"
                       :errors-bag="errors" data-vv-value-path="val"
                       data-vv-as="Nationalité">
              </v-input>
            </div>
          </div>

          <div class="column is-12 is-paddingless columns is-multiline" v-if="!fromQuickview">
            <div class="column is-4 is-paddingless-bottom">
              <div class="field">
                <r-label :label="'Situation Familiale'" :value="c.family_situation" :redCheck="hasCheck"
                         :is-required="hasCheck && isHuman && !isCorporation"></r-label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="c.family_situation">
                      <option :value="null">Selectionnez</option>
                      <option v-for="s in familySituationList" :value="s.value" :key="s.value">{{s.label}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-4 is-paddingless-bottom">
              <div class="field">
                <r-label :label="c.family_situation === 'pacs' ? 'Régime de PACS' : 'Statut Matrimonial'"
                         :value="c.matrimonial_status"
                         :redCheck="hasCheck"
                         :is-required="hasCheck && isHuman && !isCorporation && (c.family_situation === 'married' || c.family_situation === 'pacs') "></r-label>
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="c.matrimonial_status"
                            :disabled="!['married', 'pacs'].includes(c.family_situation) || c.family_situation === null">
                      <option :value="null">Selectionnez</option>
                      <option v-for="s in matrimonalStatusList" :value="s.value" :key="s.value">
                        {{s.label}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-4 is-paddingless-bottom">
              <label class="label">Nombre d'enfant</label>
              <div class="columns is-variable is-1 is-padding-left-xxsmall">
                <div class="column is-2 is-paddingless-bottom is-paddingless-top is-paddingless-left" v-for="i in 6"
                     :key="i">
                  <input class="checkradiocase is-primary is-fullwidth" :id="i - 1" type="radio" name="children"
                         :value="i - 1" v-model="c.children">
                  <label class="is-radiusless" :for="i - 1">{{i - 1}}<span v-if="i === 6">+</span></label>
                </div>
              </div>
            </div>
            <div v-if="['married', 'pacs'].includes(c.family_situation)" class="column is-12 is-paddingless columns">
              <div class="column is-4 is-paddingless-bottom">
                <r-label :label="c.family_situation === 'married' ? 'Date du mariage' : 'Date du PACS'"
                         :value="c.wedding_date" :redCheck="false" :is-required="false"></r-label>
                <div class="field has-addons">
                  <div class="control">
                    <a class="button is-static is-border is-min-width-0 is-square">
                      <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                    </a>
                  </div>
                  <div class="control is-expanded has-icons-right">
                    <flat-pickr :config="configDate" type="date" class="input is-radiusless"
                                v-model="c.wedding_date"></flat-pickr>
                  </div>
                  <div class="control">
                    <a class="button is-grey is-inverted is-border is-min-width-0 is-square"
                       @click="c.wedding_date = null">
                      <i class="fal fa-times"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-4 is-paddingless-bottom">
                <r-label :label="c.family_situation === 'married' ? 'Lieu de mariage' : 'Lieu de PACS'"
                         :value="c.wedding_place" :redCheck="false" :is-required="false"></r-label>
                <div class="field has-addons">
                  <div class="control">
                    <a class="button is-static is-border is-min-width-0 is-square">
                      <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                    </a>
                  </div>
                  <div class="control is-expanded">
                    <input type="text" class="input" v-model="c.wedding_place">
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 columns is-paddingless" v-if="!spouse">
              <div class="column is-narrow is-padding-right-xsmall">
                <button class="button is-white is-border is-rounded is-padding-right-large is-padding-left-large"
                        @click="openNewContactQuickView">
                  <span class="icon is-medium is-padding-right-xsmall"><i
                    class="is-size-4 fas fa-user-crown"></i></span>
                  <span class="is-transform-none">Créer fiche conjoint(e)</span>
                </button>
              </div>
              <div class="column is-narrow is-padding-right-xsmall">
                <button class="button is-white is-border is-rounded is-padding-right-large is-padding-left-large"
                        @click="openContactSelectionQuickView">
                  <span class="icon is-medium is-padding-right-xsmall"><i
                    class="is-size-4 fas fa-users-crown"></i></span>
                  <span class="is-transform-none">Sélectionner fiche conjoint(e)</span>
                </button>
              </div>
            </div>
            <div class="column is-6 is-paddingless-left is-paddingless-bottom is-paddingless-right" v-else>
              <label for="" class="label is-padding-left-large">Conjoint(e)</label>
              <div
                class="columns is-gapless is-margin-right is-margin-left is-margin-bottom is-border is-padding-small has-bg-white">
                <div class="column is-9 is-vcentered columns">
                  <avatar :item="spouse"></avatar>
                  <div class="is-margin-left-small">
                    <div class="title is-4">
                      <b v-if="spouse.first_name || spouse.last_name">{{spouse.first_name}} {{spouse.last_name}}</b>
                      <b v-else-if="spouse.name">{{spouse.name}}</b><br>
                      <span @click="updateSpouse()" class="is-underline is-size-6 is-italic">Modifier fiche</span>
                    </div>
                  </div>
                </div>
                <div class="column is-3 has-text-right actions">
                  <a class="button is-circle" @click="spouse = null">
                    <i class="fal fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline" v-show="displayMoreInputs" v-if="!fromLead">
          <div class="column is-4" :class="{'is-12':fromQuickview}">
            <div class="field">
              <label class="label">CSP</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="c.csp">
                    <option :value="null">Selectionnez le CSP</option>
                    <option v-for="c in contactCspList" :value="c.csp || c.value" :key="c.value">{{c.label}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-4" :class="{'is-12':fromQuickview}"
               v-if="!['unemployed', 'retirement'].includes(c.csp)">
            <div class="field">
              <r-label :label="'Profession'" :value="c.profession" :redCheck="hasCheck"
                       :is-required="hasCheck"></r-label>
              <div class="control">
                <v-input id="profession" name="profession" @input="val => c.profession = val"
                         :model="c.profession"
                         :errors-bag="errors" data-vv-value-path="val"
                         data-vv-as="Profession">
                </v-input>
              </div>
            </div>
          </div>
          <div class="column is-4" :class="{'is-12':fromQuickview}"
               v-if="!['unemployed', 'retirement'].includes(c.csp)">
            <v-input id="contact_company" name="contact_company" @input="val => c.contact_company = val"
                     :model="c.contact_company"
                     label="Société" :errors-bag="errors" data-vv-value-path="val"
                     data-vv-as="Société">
            </v-input>
          </div>
        </div>
        <div class="columns is-multiline" v-if="!fromQuickview && !fromLead">
          <a class="column is-12 has-bg-primary" @click="displayFiscalite = !displayFiscalite"
             v-scroll-to="'#fiscalite'">
            <div class="title is-5">
              <b class="is-uppercase has-text-white">
                SITUATION FISCALE
                <span class="icon"><i class="fas"
                                      :class="displayFiscalite ? 'fa-chevron-up' : 'fa-chevron-down'"></i></span>
              </b>
            </div>
          </a>
        </div>
        <div id="fiscalite"></div>
        <div class="columns is-multiline" v-show="displayFiscalite" v-if="!fromQuickview">
          <div class="column is-border-bottom is-12">
            <r-label :label="'Propriétaire ou locataire'" :value="c.is_owner" :redCheck="false"
                     :is-required="false && isHuman && !isCorporation"></r-label>
            <div class="column is-gapless is-paddingless is-12 columns is-multiline">
              <div class="column is-12 is-padding-right-small columns is-variable is-5 is-multiline">
                <div class="column is-4 is-paddingless-bottom is-paddingless-top is-paddingless-left is-padding-right">
                  <input class="checkradiocase is-primary is-fullwidth" id="ower_no" type="radio" name="nature"
                         :value="false"
                         v-model="c.is_owner">
                  <label for="ower_no">Locataire</label>
                </div>
                <div class="column is-4 is-paddingless-bottom is-paddingless-top is-paddingless-right">
                  <input class="checkradiocase is-primary is-fullwidth" id="owner_yes" type="radio" name="nature"
                         :value="true"
                         v-model="c.is_owner">
                  <label for="owner_yes">Propriétaire</label>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-paddingless has-bg-light is-border-bottom">
            <div class="column">
              <input :id="'invest'" type="checkbox" :name="'invest'"
                     class="switch is-success is-rounded is-medium" v-model="c.invest">
              <label :for="'invest'" class="label"><span
                class="is-size-6 has-text-grey">Investissement locatif</span></label>
            </div>
          </div>
          <div class="column is-12 is-paddingless columns is-padding-bottom has-bg-light is-border-bottom is-multiline"
               v-if="c.invest">
            <div class="column is-5 is-paddingless-bottom">
              <label class="label">Nature de l'investissement</label>
              <div class="field">
                <div class="control is-expanded">
                  <v-input id="invest_type" name="invest_type" @input="val => c.invest_type = val"
                           :model="c.invest_type"
                           :errors-bag="errors" data-vv-value-path="val"
                           data-vv-as="Nature de l'investissement">
                  </v-input>
                </div>
              </div>
            </div>
            <div class="column is-4 is-paddingless-bottom">
              <label class="label">Valeur de l'achat</label>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input name="invest_value" v-model.number="c.invest_value"
                         class="input" step=".01" max="100" type="number"
                         data-type-cy="input" data-value-cy="input_contact_invest_value"
                         @input="returnToNullContact('invest_value')">
                </div>
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-3 is-paddingless-bottom">
              <label class="label">Date de l'achat</label>
              <div class="field has-addons">
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                  </a>
                </div>
                <div class="control is-expanded">
                  <flat-pickr :config="configDate" type="date" class="input" v-model="c.invest_date"></flat-pickr>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-12 is-paddingless columns is-padding-bottom has-bg-light is-border-bottom is-multiline"
               v-if="displayLoans">
            <div class="column is-12 is-paddingless columns is-multiline is-variable is-2" v-for="(loan, i) in c.loans"
                 :key="i">
              <div class="column is-3 is-paddingless-bottom is-padding-left-large">
                <label class="label">Type de prêt</label>
                <div class="field">
                  <div class="control is-expanded">
                    <v-input id="loan_type" name="loan_type" @input="val => loan.loan_type = val"
                             :model="loan.loan_type"
                             :errors-bag="errors" data-vv-value-path="val"
                             data-vv-as="Type de prêt">
                    </v-input>
                  </div>
                </div>
              </div>
              <div class="column is-3 is-paddingless-bottom">
                <label class="label">Montant (mensuel)</label>
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <input name="monthly_cost" v-model.number="loan.monthly_cost"
                           class="input" step=".01" type="number"
                           data-type-cy="input" data-value-cy="input_loan_monthly_cost"
                           @input="returnToNullLoans('monthly_cost', i)">
                  </div>
                  <div class="control">
                    <a class="button is-static is-border is-min-width-0 is-square">
                      <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-3 is-paddingless-bottom">
                <label class="label">Date fin de prêt</label>
                <div class="field has-addons">
                  <div class="control">
                    <a class="button is-static is-border is-min-width-0 is-square">
                      <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                    </a>
                  </div>
                  <div class="control is-expanded">
                    <flat-pickr :config="configDate" type="date" class="input" v-model="loan.ending_date"></flat-pickr>
                  </div>
                </div>
              </div>
              <div class="column is-2 is-paddingless-bottom">
                <label class="label">Taux</label>
                <div class="field has-addons">
                  <div class="control is-expanded">
                    <input name="loan_rate" v-model.number="loan.loan_rate"
                           class="input" step=".01" max="100" type="number"
                           data-type-cy="input" data-value-cy="input_loan_loan_rate"
                           @input="returnToNullLoans('loan_rate', i)">
                  </div>
                  <div class="control">
                    <a class="button is-static is-border is-min-width-0 is-square">
                      <span class="icon"><i class="fas fa-percentage"></i></span>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column is-1 is-paddingless-bottom">
                <label class="label">&nbsp;</label>
                <div class="field">
                  <div class="control">
                    <a class="button is-border is-min-width-0 is-square is-danger is-radiusless"
                       @click="c.loans.splice(i, 1)">
                      <span class="icon"><i class="fas fa-trash"></i></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12 columns is-paddingless">
              <div class="column is-narrow is-padding-right-xsmall is-paddingless-bottom">
                <button class="button is-white is-border is-rounded is-padding-right-large is-padding-left-large"
                        @click="newLoan">
                  <span class="icon is-medium is-padding-right-xsmall"><i
                    class="is-size-4 fas fa-plus-circle"></i></span>
                  <span class="is-transform-none">Ajouter un prêt bancaire</span>
                </button>
              </div>
            </div>
          </div>
          <div class="column is-12 is-paddingless columns is-padding-bottom has-bg-light is-border-bottom is-multiline">
            <div class="column is-3 is-paddingless-bottom">
              <r-label :label="'Revenus déclarés'" :value="c.income" :redCheck="false"
                       :is-required="false"></r-label>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input name="income" v-model.number="c.income"
                         class="input" step=".01" type="number"
                         data-type-cy="input" data-value-cy="input_contact_income"
                         @input="returnToNullContact('income')">
                </div>
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-3 is-paddingless-bottom">
              <r-label :label="'Revenus foncier'" :value="c.land_income" :redCheck="false"
                       :is-required="false"></r-label>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input name="land_income" v-model.number="c.land_income"
                         class="input" step=".01" type="number"
                         data-type-cy="input" data-value-cy="input_contact_land_income"
                         @input="returnToNullContact('land_income')">
                </div>
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-3 is-paddingless-bottom">
              <r-label :label="'Montant impot'" :value="c.tax_income" :redCheck="false"
                       :is-required="false"></r-label>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input name="tax_income" v-model.number="c.tax_income"
                         class="input" step=".01" type="number"
                         data-type-cy="input" data-value-cy="input_contact_tax_income"
                         @input="returnToNullContact('tax_income')">
                </div>
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-3 is-paddingless-bottom">
              <label class="label">Parts fiscales</label>
              <div class="field">
                <div class="control is-expanded">
                  <input name="fiscal_share" v-model.number="c.fiscal_share"
                         class="input" step="1" max="100" type="number"
                         data-type-cy="input" data-value-cy="input_contact_fiscal_share"
                         @input="returnToNullContact('fiscal_share')">
                </div>
              </div>
            </div>
            <div class="column is-3 is-paddingless-bottom">
              <label class="label">Charges fixes mensuelle</label>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input name="monthly_outcome" v-model.number="c.monthly_outcome"
                         class="input" step=".01" type="number"
                         data-type-cy="input" data-value-cy="input_contact_monthly_outcome"
                         @input="returnToNullContact('monthly_outcome')">
                </div>
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-3 is-paddingless-bottom">
              <label class="label">Endettement</label>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input name="debt" v-model.number="c.debt"
                         class="input" step=".01" type="number"
                         data-type-cy="input" data-value-cy="input_contact_debt"
                         @input="returnToNullContact('debt')">
                </div>
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-3 is-paddingless-bottom">
              <label class="label">Effort d'épargne (mensuel)</label>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input name="monthly_saving" v-model.number="c.monthly_saving"
                         class="input" step=".01" type="number"
                         data-type-cy="input" data-value-cy="input_contact_monthly_saving"
                         @input="returnToNullContact('monthly_saving')">
                </div>
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-3 is-paddingless-bottom">
              <label class="label">Capital disponible</label>
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input name="available_capital" v-model.number="c.available_capital"
                         class="input" step=".01" type="number"
                         data-type-cy="input" data-value-cy="input_contact_available_capital"
                         @input="returnToNullContact('available_capital')">
                </div>
                <div class="control">
                  <a class="button is-static is-border is-min-width-0 is-square">
                    <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="panel === 'COMMENT'">
        <div class="columns is-multiline has-bg-light">
          <div class="column is-12 is-paddingless columns">
            <div class="column">
              <label for="" class="label is-padding-bottom-xsmall">Commentaire</label>
              <div class="field" @mouseover="displayToolbar = true" @mouseleave="displayToolbar = false">
                <div class="control">
                  <wysiwyg-editor :model="commentaires" placeholder="" :submited='isSubmited'
                                  :class="{'editr--hide-toolbar':!displayToolbar}" :light='true'
                                  @change="val => c.comment = val"
                                  class="editr--bottom-toolbar editr--height-large content has-bg-white"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formActionsSticky is-bottom is-margin-top" v-if="!fromQuickview">
        <div class="columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
          <div class="column is-4 is-3-widescreen is-margin-right-small">
            <button class="button is-success is-uppercase is-fullwidth" @click="saveLead()" v-if="fromLead">Enregistrer
              Lead
            </button>
            <button class="button has-bg-white is-uppercase is-fullwidth" @click="$router.goBack(route)" v-else>
              Annuler
            </button>
          </div>
          <div class="column is-4 is-3-widescreen is-margin-right-small">
            <button class="button is-success is-uppercase is-fullwidth has-text-white" @click="submit"
                    :disabled="!canSubmit || !addressIsValid || loading" :class="{'is-loading':loading}">
              <span v-if="!loading">
                <span v-if="fromLead">Convertir en contact</span>
                <span v-else>Valider</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </form>
    <span v-if='iCanSubmit'></span>
  </div>
</template>

<script>
  import { isEmpty, isNil } from 'lodash'
  import { DefaultValues } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment'

  const emptyContact = {
    title: null,
    first_name: null,
    last_name: null,
    email: null,
    mobile: null,
    phone: null,
    address: {},
    comment: null,
    birthplace: null,
    birth_name: null,
    birthday: null,
    matrimonial_status: null,
    children: null,
    nationality: null,
    csp: null,
    profession: null,
    main_residence: null,
    income: null,
    tax_income: null,
    is_owner: null,
    nature: 'human',
    corporation_name: null,
    corporation_siret: null,
    family_situation: null,
    wedding_place: null,
    wedding_date: null,
    land_income: null
  }

  export default {
    name: 'ContactForm',
    mixins: [DefaultValues],
    props: {
      source: {
        type: Object,
        required: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      fromQuickview: {
        type: Boolean,
        default: false
      },
      fromLead: {
        type: Boolean,
        default: false
      },
      sourceAddress: Object,
      params: Object,
      sourceSeller: String
    },
    data () {
      return {
        isSubmited: false,
        errorMess: false,
        inlineAddress: null,
        contact: {},
        sellers: [],
        seller: null,
        route: this.$route,
        contacts: [],
        hasCheck: false,
        isSpouse: false,
        showSellerChooser: true,
        displayToolbar: false,
        displayFiscalite: false,
        displayMoreInputs: true,
        spouse: null,
        origin: null,
        panel: 'INFOS',
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y'
        }
      }
    },
    computed: {
      ...mapState({
        originList: 'origins',
        currentUser: 'currentUser',
        quickview: 'quickview'
      }),
      ...mapGetters(['isSeller', 'isAdmin', 'isManager', 'isSectorManager', 'currentUserPk', 'isExternal', 'originGroups', 'isOperator']),
      c () {
        return this.contact
      },
      isHuman () {
        return this.c.nature && this.c.nature === 'human'
      },
      isCorporation () {
        return this.c.nature && this.c.nature === 'corporation'
      },
      addressIsEmpty () {
        return this.c.address == null || isEmpty(this.c.address)
      },
      addressIsValid () {
        return this.addressIsEmpty === false && this.c.address.city !== null && this.c.address.city !== '' && this.c.address.city !== undefined && this.c.address.zip_code !== '' && this.c.address.zip_code !== null && this.c.address.zip_code !== undefined
      },
      iCanSubmit () {
        let canCreateContact = this.errors.any() === false && this.errorMess === false && this.addressIsValid && this.c.title !== null && !isEmpty(this.c.phone) && !isEmpty(this.c.email) && !isEmpty(this.c.last_name) && !isEmpty(this.c.first_name)
        this.$emit('iCanSubmit', canCreateContact)
        return canCreateContact
      },
      canSubmit () {
        if (this.fromLead) {
          return this.contact.last_name !== null && this.contact.title !== null && this.contact.first_name !== null && this.contact.nature !== null && this.contact.email !== null && this.contact.phone !== null && this.errors.any() === false && this.addressIsValid
        } else {
          return this.errors.any() === false && this.addressIsValid
        }
      },
      displayLoans () {
        return this.c.invest || this.c.is_owner
      },
      styleBtnToggleMoreInput () {
        let styleObj = {}
        if (!this.displayMoreInputs) {
          styleObj = {
            position: 'sticky',
            bottom: '0'
          }
        }
        return styleObj
      },
      commentaires () {
        // let comments = null
        // this.c.comments.forEach(element => {
        //   if (element.to_keep === true) {
        //     if (comments === null) {
        //       comments = element.comment
        //     } else {
        //       comments = comments + '</br>' + element.comment
        //     }
        //   }
        // })
        // if (this.c.comment) {
        //   return this.c.comment + '</br>' + comments
        // } else {
        return this.c.comment
        // }
      }
    },
    watch: {
      displayLoans (v) {
        if (v && (!this.c.loans || !this.c.loans.length)) {
          this.newLoan()
        }
      },
      quickview ({ mode, params, results }) {
        if (results) {
          if (mode === 'CONTACT_SELECTION' && results.entities && results.entities.length) {
            this.spouse = results.entities[0]
          } else if (mode === 'NEW_CONTACT' && results.contact && !this.fromQuickview) {
            this.addSpouse(results.contact)
          }
        }
      }
    },
    methods: {
      // CODE TRÉS SALE A RÉFLÉCHIR PLUS TARD
      updateSpouse () {
        this.$swal({
          title: 'Souhaitez vous vraiment quitter cette fiche contact ?',
          text: 'Vous avez effectué des modifications, si vous quittez sans les enregistrer elles ne seront pas enregistrées.',
          confirmButtonText: 'Enregistrer et quitter',
          confirmButtonColor: '#81bc74',
          cancelButtonText: 'Quiter sans enregistrer',
          cancelButtonColor: '#ff0200',
          showCloseButton: true
        }).then(r => {
          if (r.value) {
            this.isSubmited = true
            this.$validator.validateAll()
              .then(isValid => {
                if (isValid) {
                  if (this.c.loans && this.c.loans.length) {
                    this.c.loans = this.c.loans.filter(x => !isEmpty(x) && !isNil(x.loan_type))
                  }
                  if (this.spouse && this.spouse.pk) this.c.spouse = this.spouse.pk
                  else this.c.spouse = this.spouse

                  if (this.origin) this.c.origin = this.origin.pk

                  this.c.seller = this.seller

                  if (this.c.birthplace === '') this.c.birthplace = null
                  if (this.c.nationality === '') this.c.nationality = null
                  if (this.fromQuickview) {
                    let contact = this.c
                    this.loading = true
                    this.$api.contactService.put(contact.pk, contact).then(r => {
                      this.loading = false
                      this.$notify({
                        type: 'is-success',
                        text: 'Le contact a bien été mis à jour'
                      })
                      this.$router.push({name: 'ContactEdit', params: {id: this.spouse.pk}})
                    }).catch(() => {
                      this.loading = false
                      this.$notify({
                        type: 'is-danger',
                        text: 'Erreur lors de la mise à jour du contact.'
                      })
                    })
                  } else {
                    let contact = this.c
                    this.loading = true
                    this.$api.contactService.put(contact.pk, contact).then(r => {
                      this.loading = false
                      this.$notify({
                        type: 'is-success',
                        text: 'Le contact a bien été mis à jour'
                      })
                      this.$router.push({name: 'ContactEdit', params: {id: this.spouse.pk}})
                    }).catch(() => {
                      this.loading = false
                      this.$notify({
                        type: 'is-danger',
                        text: 'Erreur lors de la mise à jour du contact.'
                      })
                    })
                  }
                } else {
                  this.$notify({
                    type: 'is-danger',
                    text: 'Oups ! Merci de compléter les champs obligatoires.'
                  })
                }
              })
              .catch(err => {
                console.log('form validation error > ', err)
              })
          } else if (r.dismiss === 'cancel') {
            this.$router.push({name: 'ContactEdit', params: {id: this.spouse.pk}})
          }
        })
      },
      moreInputs () {
        this.displayMoreInputs = !this.displayMoreInputs
        let label = document.querySelector('#complementary')
        this.$nextTick(() => {
          let quickview = document.querySelector('.quickview-body')
          quickview.scrollTo(0, label.offsetTop)
        })
      },
      selectedSeller () {
        this.seller = this.$route.params.seller
      },
      returnToNullContact (param) {
        if (this.contact[param] === '') {
          this.$set(this.contact, param, null)
        }
      },
      returnToNullLoans (param, i) {
        if (this.contact.loans[i][param] === '') {
          this.$set(this.contact.loans[i], param, null)
        }
      },
      // returnToNullAllLoans (i) {
      //   this.$set(this.contact.loans[i], 'monthly_cost', null)
      //   this.$set(this.contact.loans[i], 'loan_type', null)
      //   this.$set(this.contact.loans[i], 'loan_rate', null)
      //   this.$set(this.contact.loans[i], 'ending_date', null)
      // },
      saveLead () {
        this.c.seller = this.seller.pk
        this.$emit('saveLead', this.c)
      },
      submit () {
        this.isSubmited = true
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              if (this.c.loans && this.c.loans.length) {
                this.c.loans = this.c.loans.filter(x => !isEmpty(x) && !isNil(x.loan_type))
              }
              if (this.spouse && this.spouse.pk) this.c.spouse = this.spouse.pk
              else this.c.spouse = this.spouse

              if (this.origin) this.c.origin = this.origin.pk

              this.c.seller = this.seller

              if (this.c.birthplace === '') this.c.birthplace = null
              if (this.c.nationality === '') this.c.nationality = null
              if (this.fromQuickview) {
                return this.$emit('submit', { contact: this.c })
              } else {
                return this.$emit('submit', this.c)
              }
            } else {
              this.$notify({
                type: 'is-danger',
                text: 'Oups ! Merci de compléter les champs obligatoires.'
              })
            }
          })
          .catch(err => {
            console.log('form validation error > ', err)
          })
      },
      updateAddress ({ address, location }) {
        this.$set(this.contact, 'address', address)
      },
      getSellers (firstName) {
        let params = {
          profil_type: ['admin', 'seller', 'seller_ext', 'manager', 'manager_ext', 'operator', 'sector_manager']
        }
        if (firstName) {
          params.first_name = firstName
        }
        this.$api.userService.get(params).then(res => {
          this.sellers = res.data.items
        })
      },
      getOrigins () {
        this.$api.originService.get({ sort: 'name:asc' }).then(r => {
          this.origins = r.data
        })
      },
      getOrigin () {
        this.$api.originService.getOne(this.contact.origin).then(r => {
          this.origin = r.data
        })
      },
      sellerName (seller) {
        if (seller && seller.last_name) {
          return seller.first_name + ' ' + seller.last_name
        } else {
          return 'Selectionnez un vendeur'
        }
      },
      originName (origin) {
        if (origin.parent_name) {
          return origin.parent_name + ' - ' + origin.name
        } else {
          return origin.name
        }
      },
      openContactSelectionQuickView () {
        let contact = null
        if (this.c && this.c.pk) contact = this.c.pk
        let params = {
          excludes: [contact],
          mode: 'store',
          seller: this.currentUserPk
        }
        this.$store.commit('setQuickview', { mode: 'CONTACT_SELECTION', params })
      },
      openNewContactQuickView () {
        if (isEmpty(this.c.address)) {
          return this.$notify({
            type: 'is-warning',
            text: 'L\'adresse du contact est requis pour créer son conjoint.'
          })
        }
        this.$store.commit('setQuickview', {
          mode: 'NEW_CONTACT',
          params: {
            showSellerSelect: false,
            address: this.c.address,
            isSpouse: true
          }
        })
      },
      addSpouse (contact) {
        contact.seller = this.currentUserPk
        this.$api.contactService.post(contact).then(res => {
          this.spouse = res.data
          this.$notify({
            type: 'is-success',
            text: 'Le conjoint a été créé.'
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la création du conjoint.'
          })
        })
      },
      newLoan () {
        if (!Array.isArray(this.contact.loans)) this.contact.loans = []
        this.contact.loans.push({ loan_type: null, monthly_cost: null, ending_date: null, loan_rate: null })
      }
    },
    created () {
      this.isSubmited = false
      this.selectedSeller()
      if (this.source) {
        this.contact = Object.assign({}, this.source)
        if (this.contact.birthday) this.contact.birthday = moment(this.contact.birthday).format('DD/MM/YYYY')
        if (this.contact.wedding_date) this.contact.wedding_date = moment(this.contact.wedding_date).format('DD/MM/YYYY')
        if (this.contact.invest_date) this.contact.invest_date = moment(this.contact.invest_date).format('DD/MM/YYYY')
        if (this.source.seller) {
          this.$api.userService.getOne(this.source.seller).then(r => {
            this.seller = r.data
          })
        }
        if (this.contact.spouse) {
          this.spouse = { pk: this.contact.spouse, name: this.contact.spouse_name }
        }
        if (this.contact.origin) {
          this.getOrigin()
        }
      } else {
        this.contact = Object.assign({}, emptyContact)
      }
      if (this.sourceSeller) {
        this.$api.userService.getOne(this.sourceSeller).then(r => {
          this.seller = r.data
        })
      }
      if (this.sourceAddress && isEmpty(this.contact.address)) {
        this.contact.address = this.sourceAddress
      }
      if (this.isSeller) {
        this.showSellerChooser = false
        this.contact.seller = this.currentUserPk
        this.seller = this.currentUser
      }
      if (this.params && this.params.isSpouse) {
        this.isSpouse = true
      }
      if (this.fromQuickview) {
        this.displayMoreInputs = false
      }
      this.getSellers()
      if (!this.origins || !this.origins.length) {
        this.origins = this.originList.slice()
      }
      if ('check' in this.$route.query) {
        this.hasCheck = true
        this.displayFiscalite = true
      }
      if ('panel' in this.$route.query) {
        this.panel = this.$route.query.panel
      }
      if (!this.seller) {
        this.seller = this.currentUser
      }
    },
    mounted () {
      if (this.fromQuickview) {
        let quickview = document.querySelector('.quickview-body')
        quickview.addEventListener('scroll', this.QuickViewScroll)
      }
    },
    destroyed () {
      if (this.fromQuickview) {
        let quickview = document.querySelector('.quickview-body')
        quickview.removeEventListener('scroll', this.QuickViewScroll)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactForm.vue